import React, { useState, useEffect } from 'react';

const UpgradeToContinue: React.FC<{ message: string }> = ({ message }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(true);
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    // Navigate to the home page
    window.location.href = '/';
  };

  if (!isOpen) return null;

  return (
    <>
      <style>{`
        .upgrade-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          backdrop-filter: blur(5px);
        }

        .upgrade-modal {
          background-color: white;
          border-radius: 8px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          padding: 2rem;
          max-width: 500px;
          width: 90%;
          position: relative;
          animation: modalFadeIn 0.3s ease-out;
        }

        @keyframes modalFadeIn {
          from { opacity: 0; transform: scale(0.9); }
          to { opacity: 1; transform: scale(1); }
        }

        .close-button {
          position: absolute;
          top: 10px;
          right: 10px;
          background: none;
          border: none;
          font-size: 1.5rem;
          cursor: pointer;
          color: #666;
        }

        .upgrade-content {
          text-align: center;
        }

        h2 {
          color: #333;
          margin-bottom: 1rem;
        }

        .upgrade-message {
          font-size: 1.1rem;
          color: #555;
          margin-bottom: 1rem;
        }

        .upgrade-description {
          color: #666;
          margin-bottom: 1.5rem;
        }

        .upgrade-benefits {
          display: flex;
          justify-content: space-around;
          margin-bottom: 1.5rem;
        }

        .benefit-item {
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .benefit-icon {
          font-size: 2rem;
          margin-bottom: 0.5rem;
        }

        .upgrade-button {
          display: inline-block;
          background-color: #4CAF50;
          color: white;
          text-decoration: none;
          padding: 0.8rem 1.5rem;
          border-radius: 25px;
          font-weight: bold;
          transition: background-color 0.3s ease;
        }

        .upgrade-button:hover {
          background-color: #45a049;
        }
      `}</style>
      <div className="upgrade-modal-overlay">
        <div className="upgrade-modal">
          <button className="close-button" onClick={handleClose}>&times;</button>
          <div className="upgrade-content">
            <h2>Unlock Premium Features</h2>
            <p className="upgrade-message">{message}</p>
            <p className="upgrade-description">
              Take your experience to the next level with unlimited access to company data and advanced features.
            </p>
            <div className="upgrade-benefits">
              <div className="benefit-item">
                <span className="benefit-icon">🔍</span>
                <span>Deep Insights</span>
              </div>
              <div className="benefit-item">
                <span className="benefit-icon">⚡</span>
                <span>Unlimited Access</span>
              </div>
              <div className="benefit-item">
                <span className="benefit-icon">🤖</span>
                <span>AI-Powered Research</span>
              </div>
            </div>
            <a href="/pricing" className="upgrade-button">Upgrade Now</a>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpgradeToContinue;
